module.exports = __webpack_public_path__ + "static/media/door-symbol.a6629f00.svg";